export const SALON_SET_PROVINCE = 'SALON_SET_PROVINCE';
export const SALON_SET_ALL_SALON = 'SALON_SET_ALL_SALON';
export const SALON_SET_TOP_SALON = 'SALON_SET_TOP_SALON';
export const SALON_SET_TOP_SALON_BOOKING = 'SALON_SET_TOP_SALON_BOOKING';